export default __webpack_public_path__ + "static/media/f.e431ecd8.mp3";